$(function(){
  var href = window.location.href;
  var collectionName = href.split('/').pop();
  if (collectionName === 'top100') {
    if ($('.view-timer').length == 0) {
      $('#collection-main').prepend(`<div class="view-timer"></div>`);
    }
    var email = localStorage.getItem('customerEmail');
    if(email){
      getTaskStatus();
    }
    var findEmail = setInterval(() => {
      if(email){
        clearInterval(findEmail);
        return;
      }
      email = localStorage.getItem('customerEmail');
      if (email) {
        clearInterval(findEmail);
        getTaskStatus();
      }
    },2000);
  }

  //查询任务是否完成
  function getTaskStatus(){
    var params = {
      region: 'JP',
      thirdCustId: email,
    };
    scoresAjax('get-customer-task-times', params).then((data) => {
      var taskViewProduct = data.find((item) => item.type == 3);
      if (taskViewProduct.times > 0) {
        $('.view-timer').html('本日のブラウジングタスクは完了しました');
        return;
      }
      setCountDown(30, params);
    });
  }
  //30秒倒计时 结束时加20积分
  function setCountDown(leftTime, params) {
    var timer = null;
    timer = setInterval(() => {
      var m = 0;
      var s = 0;
      if (leftTime > 0) {
        m = Math.floor((leftTime / 60) % 60);
        s = Math.floor(leftTime % 60);
      } else {
        clearInterval(timer);
        params = Object.assign(params, { type: '3', integral: '20' });
        scoresAjax('add-integral', params)
          .then((data) => {
            toastMessage('30秒の閲覧完了、20ポイント獲得！');
          })
          .catch((err) => {
            console.log(err);
          });
      }
      leftTime--;
      m = m.toString().padStart(2, '0');
      s = s.toString().padStart(2, '0');
      $('.view-timer').html(
        `ミッション完了まで残り<span class="minutes">${m}</span>:<span class="seconds">${s}</span>s`
      );
    }, 1000);
  }

});